export default "__VITE_ASSET__62fed4b6__"